<!--
Author:
Create Time: 2020-04-13 09:22:08
Description: 人口信息选择框
-->
<template>
  <div class="com-populregister-select">
      <span>
          <el-input
            placeholder
            v-model="label"
            @focus="handleInputClick"
            :disabled="disabled"
            data-ignore-clearable="true"
            data-ignore-at-clear="handleClear"
            :title="label"
          >
          <i
          class="el-icon-search el-input__icon"
          slot="suffix">
        </i></el-input>
      </span>

      <proRewardPunishRegisterRef
        ref="proRewardPunishRegisterRef"
        :visible="isproRewardPunishRegisterRefVisible"
        @confirm="handleproRewardPunishRegisterRefConfirm"
        :multiple="multiple"
        @cancel="handleproRewardPunishRegisterRefCancel"
        append-to-body
        width="65%"
      />
  </div>
</template>

<script>
export default {
  name: 'proRewardPunishRegisterSelect',
  props: {
      value: {
          type: [String, Array, undefined],
          default: () => ''
      },
      label: {
          type: String,
          default: () => ''
      },
      disabled: {
          type: Boolean,
          default: () => false
      },
  },
  data () {
    return {
        isproRewardPunishRegisterRefVisible: false,
    }
  },
  computed: {
      multiple() {
          return Array.isArray(this.value);
      },
  },
  methods: {
      handleInputClick() {
          this.isproRewardPunishRegisterRefVisible = true;
      },
      handleClear() {},
      handleproRewardPunishRegisterRefConfirm(value) {
          let val = Array.isArray(value) ? value.map(o => o.id) : value.id;
          this.$emit('update:value', val, value);
          this.$emit('change', val, value);
          this.$emit('input', val, value);
          this.isproRewardPunishRegisterRefVisible = false;
      },
      handleproRewardPunishRegisterRefCancel() {
          this.isproRewardPunishRegisterRefVisible = false;
      },
  }
}
</script>

<style scoped lang="less">
.com-populregister-select {
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/proRewardPunishRegister/proRewardPunishRegisterSelect.vue